import { render, staticRenderFns } from "./TemplatePortrait.vue?vue&type=template&id=cce9b69c&scoped=true&"
import script from "./TemplatePortrait.vue?vue&type=script&lang=js&"
export * from "./TemplatePortrait.vue?vue&type=script&lang=js&"
import style0 from "./TemplatePortrait.vue?vue&type=style&index=0&id=cce9b69c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce9b69c",
  null
  
)

export default component.exports